<template>
  <div>
    <toast :is-show="loading" icon="loading" text="加载中"></toast>
    <toast
      :is-show.sync="hasError"
      icon="none"
      :text="errorTips"
      :auto-hide="true"
    ></toast>
    <div class="mwe-page">
      <div class="mwe-page-hd">
        <!-- SLOGAN S  -->
        <section class="act-slogo">
          <h1 class="act-slogo-tit">
            腾讯引进 Nintendo Swithc 发售周年庆
          </h1>
          <h2 class="act-slogo-slogan">12.10 ~ 12.12 回馈福利送不停</h2>
        </section>
        <!-- SLOGAN E  -->

        <!-- 顶部链接导航 S  -->
        <video-swiper :show.sync="showBuyGuidePopbox"></video-swiper>
        <!-- 收起：act-header-link act-header-link--mini -->
        <!-- 展开：act-header-link -->
        <section v-if="navFixTop" class="act-header-link">
          <div class="act-linkbar">
            <div class="act-linkbar-inner">
              <a class="act-linkbar-item">
                <span class="act-linkbar-item-txt" @click="goLink('/prize')"
                  >我的奖品</span
                >
              </a>
              <a class="act-linkbar-item">
                <span class="act-linkbar-item-txt" @click="goLink('/rule')"
                  >规则</span
                >
              </a>
            </div>
          </div>
        </section>
        <section id="actHeaderId" class="act-header-link act-header-link--mini">
          <div class="act-linkbar">
            <div class="act-linkbar-inner">
              <a class="act-linkbar-item">
                <span class="act-linkbar-item-txt" @click="goLink('/prize')"
                  >我的奖品</span
                >
              </a>
              <a class="act-linkbar-item">
                <span class="act-linkbar-item-txt" @click="goLink('/rule')"
                  >规则</span
                >
              </a>
            </div>
          </div>
        </section>
        <!-- 顶部链接导航 E  -->
      </div>
      <div class="mwe-page-bd">
        <!-- 抢红包预告 S  -->
        <section class="page-panel-time">
          <panel>
            <!-- 标题 -->
            <template slot="title">
              <span>每日12点抢e商店无门槛红包</span>
            </template>

            <!-- 描述 -->
            <!-- <template slot="desc">
                        <span>描述</span>
                    </template> -->

            <div class="act-list act-list--cols act-list--3 list-voucher">
              <div class="act-list-inner">
                <!-- 其他日期：act-list-item   -->
                <!-- 当前日期：act-list-item cur  -->

                <div
                  v-for="(item, index) in scrambleCouponsInfo"
                  :key="index + 'a'"
                  class="act-list-item"
                  :class="[
                    item.scrambleState.id === SCRAMBLE_STATE_MAP.STARTING
                      ? 'cur'
                      : ''
                  ]"
                >
                  <div class="list-time">
                    <div class="list-time-tit">12月{{ 10 + index }}日</div>
                    <div class="list-time-desc">12:00</div>
                  </div>
                  <div class="voucher voucher--v">
                    <div class="voucher-inner">
                      <div class="voucher-hd">
                        <div class="voucher-price">
                          <span class="voucher-price-unit">¥</span>
                          <span class="voucher-price-val">15</span>
                          <span class="voucher-price-cnunit">元</span>
                        </div>
                      </div>

                      <div class="voucher-bd">
                        <!-- 按钮--立即抢券--已抢光：act-button button-end -->
                        <!-- 按钮--立即抢券--可领取：act-button -->
                        <!-- 按钮--立即抢券--未开始：act-button button-future -->
                        <div
                          class="act-button"
                          :class="{
                            'button-end':
                              item.scrambleState.id ===
                              SCRAMBLE_STATE_MAP.COMPLETED,
                            'button-future':
                              item.scrambleState.id ===
                                SCRAMBLE_STATE_MAP.NOT_STARTED ||
                              item.scrambleState.id ===
                                SCRAMBLE_STATE_MAP.RECEIVED
                          }"
                          @click="scrambleCoupon(item)"
                        >
                          <span class="act-button-txt">
                            {{
                              item.scrambleState.id ===
                              SCRAMBLE_STATE_MAP.COMPLETED
                                ? '已抢光'
                                : item.scrambleState.id ===
                                  SCRAMBLE_STATE_MAP.RECEIVED
                                ? '已领取'
                                : item.scrambleState.id ===
                                  SCRAMBLE_STATE_MAP.NOT_STARTED
                                ? '未开始'
                                : '立即抢券'
                            }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 预约模块 S -->
              <div v-if="showAppointment" class="order-wrap">
                <!-- 按钮--预约提醒--已预约：act-button disabled -->
                <!-- 按钮--预约提醒：act-button -->
                <div class="act-button" :class="{ disabled: isRegistered }">
                  <span class="act-button-txt" @click="appointment"
                    >预约提醒</span
                  >
                </div>
              </div>
              <!-- 预约模块 E -->
            </div>
          </panel>
        </section>
        <!-- 抢红包预告 E  -->

        <!-- 抽奖 S  -->
        <section class="page-panel-lottery">
          <panel>
            <!-- 标题 -->
            <template slot="title">
              <span>国行老用户Q币回馈抽奖</span>
            </template>

            <!-- 描述 -->
            <template slot="desc">
              <span>抽奖活动时间：12月10日-12日</span>
            </template>

            <!-- 提示：购买游戏提示 S -->
            <div class="lottery-tips">
              <span>12月10日前有</span>
              <strong class="highlight">购买且激活</strong>
              <span
                >过国行游戏并<strong class="highlight"
                  >关注官方微信公众号</strong
                >的用户，即可参与抽奖</span
              >
            </div>
            <!-- 提示：购买游戏提示 E -->

            <!-- 提示：关注微信公众号 S -->
            <div
              v-if="
                lotteryInfo &&
                !lotteryInfo.alreadyDrew &&
                lotteryInfo.isPlayedSwitch &&
                !lotteryInfo.isSubscribed
              "
              class="lottery-tips-follow"
            >
              <span>您还未关注微信公众号，关注并购买激活游戏可参与抽奖</span>
              <span class="lottery-tips-button" @click="handleQRCode(false)"
                >去关注</span
              >
            </div>

            <!-- 提示：你已获得抽奖资格 S -->
            <div v-else class="lottery-tips-strong">
              {{
                (lotteryInfo &&
                  lotteryInfo.isPlayedSwitch &&
                  lotteryInfo.isSubscribed) ||
                lotteryInfo.alreadyDrew
                  ? '您已获得抽奖资格'
                  : '您尚未获得抽奖资格'
              }}
            </div>
            <!-- 提示：你已获得抽奖资格 E -->
            <!-- 提示：关注微信公众号 E -->
            <!-- 提示：购买游戏 S -->
            <!-- <div
              v-if="
                lotteryInfo &&
                !lotteryInfo.alreadyDrew &&
                lotteryInfo.isSubscribed &&
                !lotteryInfo.isPlayedSwitch
              "
              class="lottery-tips-follow"
            >
              <span>购买任一游戏即可参与抽奖</span>
              <span class="lottery-tips-button" @click="handleBuyGuide"
                >去国行e商店购买</span
              >
            </div> -->
            <!-- 提示：购买游戏 E -->
            <div class="lottery-box">
              <div class="lottery-box-inner">
                <!-- 控制 lottery-box-img 旋转角度 S  -->
                <div
                  class="lottery-box-img"
                  :style="`transform: rotate(${rotateDeg}deg);`"
                ></div>
              </div>
              <!-- 抽奖按钮 S  -->
              <!-- 抽奖:lottery-box-button -->
              <!-- 抽奖:lottery-box-button disabled -->
              <div
                class="lottery-box-button"
                :class="{
                  disabled:
                    lotteryInfo.alreadyDrew ||
                    !lotteryInfo.isPlayedSwitch ||
                    !lotteryInfo.isSubscribed
                }"
              >
                <div class="lottery-box-button-item" @click="drawLottery"></div>
              </div>
              <!-- 抽奖按钮 E  -->
            </div>
          </panel>
        </section>
        <!-- 抽奖 E  -->

        <!-- 抽奖 S  -->
        <section class="page-panel-voucher">
          <panel class="mwe-panel--expand mwe-panel--expand--show">
            <!-- mwe-panel--expand--show 显示 -->
            <!-- mwe-panel--expand--hide 隐藏 -->
            <!-- 标题 -->
            <template slot="title">
              <span>购买返券，尽享多重优惠</span>
            </template>
            <div class="mwe-panel-expand-content">
              <!-- 优惠券 S  -->
              <div class="act-list act-list--row list-receive-voucher">
                <div class="act-list-inner">
                  <div
                    v-for="(item, index) in rewardCouponsInfo"
                    :key="index + 'b'"
                    class="act-list-item"
                  >
                    <div class="voucher voucher--h">
                      <div class="voucher-inner">
                        <div class="voucher-hd">
                          <div class="voucher-price">
                            <span class="voucher-price-unit">¥</span>
                            <span class="voucher-price-val">{{
                              REWARD_PHASE_MAP[item.rewardPhase].value
                            }}</span>
                            <!-- <span class="voucher-price-cnunit">元</span> -->
                          </div>
                        </div>
                        <div class="voucher-bd">
                          <h3 class="voucher-name">优惠券</h3>
                          <p class="voucher-extra-tip">
                            {{ REWARD_PHASE_MAP[item.rewardPhase].useScope }}
                          </p>
                        </div>
                        <div class="voucher-ft">
                          <!-- 按钮--立即领取--已领取：act-button button-end -->
                          <!-- 按钮--立即领取--可领取：act-button -->
                          <!-- 按钮--立即领取--暂不可领取：act-button button-future -->
                          <div
                            class="act-button act-button--size-m"
                            :class="{
                              'button-end': item.alreadyReceived,
                              'button-future': !item.hasQualification
                            }"
                            @click="receiveReward(item)"
                          >
                            <span class="act-button-txt">
                              {{ item.alreadyReceived ? '已领取' : '立即领取' }}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="voucher-tips">
                        {{ REWARD_PHASE_MAP[item.rewardPhase].desc }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="act-list-tips">
                  以上优惠均不可叠加使用
                </div>
              </div>
              <!-- 优惠券 E  -->
              <!-- 购买流程介绍 S -->
              <widget-intro v-if="showIntro"></widget-intro>
              <!-- 购买流程介绍 E -->
            </div>
          </panel>
          <!-- 折叠收起按钮 S -->
          <div
            class="act-panel-collapse-btn"
            :class="[showIntro ? 'arrow-up' : 'arrow-down']"
            @click="handleIntro"
          >
            <div class="act-panel-collapse-icon">使用优惠券方式说明</div>
          </div>
          <!-- 折叠收起按钮 E -->
        </section>
        <!-- 抽奖 E  -->
      </div>
      <!-- 抽奖结果提示：谢谢参与  S  -->
      <!-- 显示：show -->
      <!-- 显示带动画3S消失：show-and-hide -->
      <div class="mwe-toast" :class="[showNotWin ? 'show' : 'hide']">
        <div class="mwe-toast-inner">
          {{ notWinText }}
        </div>
      </div>
      <!-- 抽奖结果提示：谢谢参与  E  -->

      <!-- 注意：  -->
      <!-- 常规弹框--关注官方微信公众号  S  -->
      <!-- 默认隐藏  -->
      <!-- 显示:show  -->
      <!-- 隐藏:hide  -->
      <mwe-popbox
        :show.sync="showQRCodePopbox"
        class="popbox-qrcode-follow show"
      >
        <template slot="title">
          <span>关注官方微信公众号</span>
        </template>

        <div class="popbox-qrcode-cont">
          <div class="qrcode-img">
            <img src="@/assets/img/popbox/qrcode.jpg" />
          </div>
          <p class="popbox-qrcode-cont-text">
            长按识别二维码
          </p>
        </div>
      </mwe-popbox>
      <!-- 常规弹框  E  -->
      <!-- 常规弹框--去国行e商店购买  S  -->
      <!-- 默认隐藏  -->
      <!-- 显示:show  -->
      <!-- 隐藏:hide  -->
      <mwe-popbox :show.sync="showBuyGuidePopbox" class="popbox-estore show">
        <template slot="title">
          <span>去国行e商店购买</span>
        </template>

        <!-- 购买流程介绍 S -->
        <widget-intro :show-pay="false"></widget-intro>
        <!-- 购买流程介绍 E -->

        <template slot="button">
          <a class="mwe-button" @click="showBuyGuidePopbox = false">
            <span class="mwe-button-txt">
              我知道了
            </span>
          </a>
        </template>
      </mwe-popbox>
      <!-- 常规弹框  E  -->

      <!-- 常规弹框--去国行e商店购买  S  -->
      <!-- 默认隐藏  -->
      <!-- 显示:show  -->
      <!-- 隐藏:hide  -->
      <mwe-popbox
        :show.sync="showAppointmentPopbox"
        class="popbox-follow-wechat show"
      >
        <template slot="title">
          <span>预约成功</span>
        </template>

        <!-- 购买流程介绍 S -->
        <div class="popbox-alert">
          <!-- 图标：成功 popbox-alert-icon popbox-alert-icon--success -->
          <span class="popbox-alert-icon popbox-alert-icon--success"></span>
          <p>
            请关注腾讯Nintendo Switch官方微信公众号， 才能接收到提醒哦。
          </p>
        </div>
        <!-- 购买流程介绍 E -->
        <template v-if="!isSubscribed" slot="button">
          <a class="mwe-button" @click="handleQRCode">
            <span class="mwe-button-txt">
              去微信关注
            </span>
          </a>
        </template>
      </mwe-popbox>
      <!-- 常规弹框  E  -->

      <!-- 活动弹窗 恭喜获得弹窗 S -->
      <act-popbox :show.sync="showWinPrize">
        <template slot="act-title"></template>
        <template slot="act-cont">
          <div class="coin-img">
            <img :src="winPrizeInfo.image" alt="" />
          </div>
          <div class="coin-text">{{ winPrizeInfo.value }}Q币</div>
          <div class="coin-time">
            有效期12.10-12.30
          </div>
        </template>
        <template slot="act-close"></template>
      </act-popbox>
      <act-popbox :show.sync="showWinCoupon">
        <template slot="act-title"></template>
        <template slot="act-cont">
          <div class="securities-info">
            <div class="securities-price">
              <span class="securities-unit">￥</span>
              <span class="securities-nums">{{ winCouponInfo.value }}</span>
              <span class="securities-unit">元</span>
            </div>
            <div class="securities-time">
              有效期12.10-12.12
              <!-- 优惠券日期固定 -->
            </div>
          </div>
          <div class="securities-text">{{ winCouponInfo.desc }}</div>
        </template>
        <template slot="act-close"></template>
      </act-popbox>
      <!-- 活动弹窗 恭喜获得弹窗 E -->
    </div>
  </div>
</template>

<script>
import { pgvEventReport } from '@/libs/tcss-report';
import {
  USER_ERROR_MESSAGE,
  PRIZE_ID_MAP,
  SCRAMBLE_STATE_MAP,
  LOTTERY_PRIZE_ID_MAP,
  REWARD_PHASE_MAP,
  COUPON_PRIZE_ID_MAP,
  ERROR_CODES
} from '@/libs/constant';
import {
  getScrambleCoupon,
  getActivityInfo,
  registerRemind,
  drawLottery,
  receiveRewardCoupon,
  scrambleCoupon
} from '@/libs/api';
import WidgetIntro from '@/components/widget-intro.vue';
import MwePopbox from '@/components/mwe-popbox';
import ActPopbox from '@/components/act-popbox';
import VideoSwiper from '@/components/video-swiper';
import Panel from '@/components/panel.vue';
import Toast from '@/components/toast';
import { randomGameArr, dateFormat, getQueryString } from '@/libs/utils';

export default {
  name: 'Home',
  components: {
    Toast,
    Panel,
    WidgetIntro,
    MwePopbox,
    ActPopbox,
    VideoSwiper
  },
  data() {
    return {
      navFixTop: false, // 导航吸顶
      dateFormat,
      PRIZE_ID_MAP,
      LOTTERY_PRIZE_ID_MAP, // 抽奖奖品
      REWARD_PHASE_MAP,
      SCRAMBLE_STATE_MAP,
      COUPON_PRIZE_ID_MAP,
      loading: false,
      lotterying: false, // 转盘在loading时候
      hasError: false,
      errorTips: USER_ERROR_MESSAGE,
      scrambleCouponsInfo: [], // 抢券信息
      rewardCouponsInfo: [], // 返券模块优惠券
      isSubscribed: false, // 是否关注公众号
      isRegistered: false, // 是否预约了提醒
      lotteryInfo: '', // 抽奖信息
      showAppointmentPopbox: false,
      showQRCodePopbox: false, // 关注二维码弹窗
      showBuyGuidePopbox: false, // 国行购买流程
      rotateDeg: 0, // 转盘选中角度
      intervalTimer: '', // 转盘时间
      showNotWin: false, // 未中奖提示
      winPrizeInfo: '', // 奖品信息
      showWinPrize: false, // 抽奖奖品弹窗
      showWinCoupon: false, // 优惠券弹窗
      winCouponInfo: '', // 获取优惠券
      showIntro: false, // 使用说明
      notWinText: ''
    };
  },
  computed: {
    // 抢券活动都已经开始-不显示预约
    showAppointment() {
      if (this.isRegistered) {
        // 已预约
        return false;
      }
      if (this.scrambleCouponsInfo.length) {
        return this.scrambleCouponsInfo[2].scrambleState.id === 10;
      }
      return false;
    }
  },
  mounted() {
    window.addEventListener('scroll', this.onPageScroll);
    const queryType = getQueryString('type');
    if (queryType && queryType === 'template') {
      pgvEventReport('anniversary.activity.pageFrom.template');
    }
    pgvEventReport('anniversary.activity.page.home');
    this.getPageInfo();
  },
  methods: {
    handleErrorMsg(errorCode) {
      // 超过预约提醒
      if (errorCode === ERROR_CODES.EXCEED_REGISTER_TIME) {
        this.errorTips = '目前无法预约，请注意抢券时间哦';
        // 不在活动期间内 - 活动已过期
      } else if (errorCode === ERROR_CODES.NOT_IN_EVENT_PERIOD) {
        this.errorTips = '活动已过期';
      } else {
        this.errorTips = USER_ERROR_MESSAGE;
      }
      this.hasError = true;
    },
    onPageScroll() {
      const scrollTop =
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        window.pageYOffset;
      const ele = this.$el.querySelector('#actHeaderId');
      if (ele) {
        if (scrollTop - ele.offsetTop > 0) {
          this.navFixTop = true;
        } else {
          this.navFixTop = false;
        }
      }
    },
    handleIntro() {
      this.showIntro = !this.showIntro;
    },
    // e商店购买
    handleBuyGuide() {
      pgvEventReport('anniversary.activity.qualification.eshopBtn');
      this.showBuyGuidePopbox = true;
    },
    // 显示二维码弹窗
    handleQRCode(isAppoint = true) {
      if (isAppoint) {
        pgvEventReport('anniversary.activity.appointment.subscribedBtn');
        this.showAppointmentPopbox = false;
      } else {
        pgvEventReport('anniversary.activity.qualification.subscribedBtn');
      }
      this.showQRCodePopbox = true;
    },
    // 预约公众号
    async appointment() {
      try {
        // 已经预约了
        if (this.isRegistered || this.loading || this.lotterying) {
          return;
        }
        pgvEventReport('anniversary.activity.appointmentBtn.click');
        this.loading = true;
        // 预约公众号
        await registerRemind();
        this.isRegistered = true;
        this.showAppointmentPopbox = true;
        this.loading = false;
      } catch (error) {
        // 超过预约提醒
        this.handleErrorMsg(error.code);
        this.loading = false;
      }
    },
    // 页面跳转
    goLink(path) {
      this.$router.push({
        path
      });
    },
    async drawLottery() {
      try {
        // 已经抽奖，或者无抽奖资格
        if (
          this.lotteryInfo.alreadyDrew ||
          !this.lotteryInfo.isPlayedSwitch ||
          !this.lotteryInfo.isSubscribed ||
          this.loading ||
          this.lotterying
        ) {
          if (this.lotteryInfo.alreadyDrew) {
            this.hasError = true;
            this.errorTips = '已经抽过了哦～';
          }
          return;
        }
        this.lotterying = true;
        // 转动转盘
        this.intervalTimer = setInterval(() => {
          this.rotateDeg = (this.rotateDeg + 20) % 360;
        }, 50);
        // 1s后开始调用结果
        setTimeout(async () => {
          try {
            const drawLotteryRes = await drawLottery();
            // 奖品
            let targetDeg = 0; // 轮盘目标角度
            if (
              drawLotteryRes.winPrizeInfo &&
              drawLotteryRes.winPrizeInfo.prizeId
            ) {
              const winPrize =
                LOTTERY_PRIZE_ID_MAP[drawLotteryRes.winPrizeInfo.prizeId];
              this.winPrizeInfo = Object.assign(
                {},
                drawLotteryRes.winPrizeInfo,
                winPrize
              );
              // 计算目标角度
              targetDeg = winPrize.deg;
              // 弹奖品窗
              this.stopDrawLottery(targetDeg, drawLotteryRes);
            } else {
              const arr = [90, 210, 330];
              const randomValue = randomGameArr(arr, 1);
              // 未中奖——90, 210, 330
              targetDeg = randomValue && randomValue[0];
              this.winPrizeInfo = '';
              this.stopDrawLottery(targetDeg, drawLotteryRes);
            }
          } catch (error) {
            this.handleErrorMsg(error.code);
            this.rotateDeg = 0;
            this.clearTimer();
            this.lotterying = false;
          }
        }, 1000);
      } catch (error) {
        // 重置
        this.handleErrorMsg(error.code);
        this.rotateDeg = 0;
        this.clearTimer();
        this.lotterying = false;
      }
    },

    handleLotteryResult() {
      if (this.winPrizeInfo) {
        this.showWinPrize = true;
        this.lotterying = false;
      } else {
        this.showNotWin = true;
        this.notWinText = '谢谢参与';
        // 2s后消失
        setTimeout(() => {
          this.showNotWin = false;
          this.lotterying = false;
        }, 2000);
      }
    },
    // 停止转盘转动
    stopDrawLottery(targetDeg, drawLotteryRes) {
      this.clearTimer();
      const stopTimer = setInterval(() => {
        // 停止的时候多旋转1圈
        if (this.rotateDeg < targetDeg + 360) {
          this.rotateDeg = this.rotateDeg + 10;
        } else {
          clearInterval(stopTimer); // 停止
          this.handleLotteryResult();
          // 等待转盘结束后再设值
          this.lotteryInfo = {
            isPlayedSwitch: drawLotteryRes.isPlayedSwitch,
            isSubscribed: drawLotteryRes.isSubscribed,
            alreadyDrew: drawLotteryRes.alreadyDrew
          };
        }
      }, 50);
    },
    // 清除旋转
    clearTimer() {
      clearInterval(this.intervalTimer);
      this.intervalTimer = '';
    },
    async getPageInfo() {
      try {
        this.loading = true;
        const scrambleCouponsRes = await getScrambleCoupon();
        this.scrambleCouponsInfo = scrambleCouponsRes.scrambleCouponsInfo;
        this.isRegistered = scrambleCouponsRes.isRegistered;
        this.isSubscribed = scrambleCouponsRes.isSubscribed;
        const result = await getActivityInfo();
        // 接口数据-赋值
        this.rewardCouponsInfo = result[0].rewardCouponsInfo;
        this.lotteryInfo = {
          isPlayedSwitch: result[1].isPlayedSwitch,
          isSubscribed: result[1].isSubscribed,
          alreadyDrew: result[1].alreadyDrew
        };
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.handleErrorMsg(error.code);
      }
    },
    // 领取购买返券
    async receiveReward(item) {
      try {
        // 没有资格或已领取
        if (
          !item.hasQualification ||
          item.alreadyReceived ||
          this.loading ||
          this.lotterying
        ) {
          // 没有资格提示 - 还未满足领取条件哦
          if (!item.hasQualification) {
            this.hasError = true;
            this.errorTips = '还未满足领取条件哦';
          }
          return;
        }
        this.loading = true;
        const rewardCouponsInfoRes = await receiveRewardCoupon(
          item.rewardPhase
        );
        this.rewardCouponsInfo = rewardCouponsInfoRes.rewardCouponsInfo;
        // 领取成功
        this.winCouponInfo = COUPON_PRIZE_ID_MAP[item.prizeId];
        this.showWinCoupon = true;
        this.loading = false;
      } catch (error) {
        this.handleErrorMsg(error.code);
        this.loading = false;
      }
    },
    // 抢周年庆优惠券
    async scrambleCoupon(item) {
      try {
        if (
          item.scrambleState.id !== SCRAMBLE_STATE_MAP.STARTING ||
          this.loading ||
          this.lotterying
        ) {
          return;
        }
        this.loading = true;
        const scrambleCouponsRes = await scrambleCoupon(item.dayNo);
        this.scrambleCouponsInfo = scrambleCouponsRes.scrambleCouponsInfo;
        if (scrambleCouponsRes.isCrambleSuccess) {
          this.winCouponInfo = COUPON_PRIZE_ID_MAP[item.prizeId];
          this.showWinCoupon = true;
        } else {
          this.showNotWin = true;
          this.notWinText = '已抢光';
          // 2s后消失
          setTimeout(() => {
            this.showNotWin = false;
          }, 2000);
        }
        this.loading = false;
      } catch (error) {
        this.handleErrorMsg(error.code);
        this.loading = false;
      }
    }
  }
};
</script>
<style lang="scss">
@import '../assets/css/pages/index.css';
</style>
